export const PENDING_STATES = ['in_queue', 'in_progress', 'finalizing']
export const ERROR_STATES = ['timeout', 'failure']
